import { queryClient } from '@vlabs/api';
import { getCreateCardMutationOptions } from '@vlabs/api/artemy/client';
import type { CardId } from '@vlabs/api/artemy/model';
import i18next from 'i18next';
import { toast } from 'react-toastify';

import type { TCreateCardFormData } from './types.point3';

export async function createCardFormSubmitHandlerPoint3({
  fio,
  lists,
}: TCreateCardFormData): Promise<CardId | undefined> {
  try {
    const [createCardResult] = await queryClient.mutateAsync(
      getCreateCardMutationOptions(queryClient),
      {
        data: {
          user_data: { fio },
          lists: (lists ?? [])?.length > 0 ? lists : undefined,
        },
      },
    );

    return createCardResult.card_id as CardId;
  } catch {
    toast.error(i18next.t('lunapoint:картотека.ошибка.label'));
    return undefined;
  }
}
